/* eslint-disable @typescript-eslint/no-explicit-any */

declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
  }
}

/**
 * Initialize Google Analytics (gtag)
 * This replaces the inline script from index.html
 *
 * IMPORTANT: This must match the original inline script pattern exactly.
 * The original used `dataLayer.push(arguments)` not `dataLayer.push(args)`.
 * GTM expects the arguments object to be pushed directly.
 */
export const initializeGoogleAnalytics = () => {
  const measurementId = import.meta.env.VITE_ANALYTICS_MEASUREMENT_ID;

  if (!measurementId) {
    console.warn('Google Analytics measurement ID not found');
    return;
  }

  // Initialize dataLayer - must match original pattern exactly
  window.dataLayer = window.dataLayer || [];

  // Set up gtag function - MUST match original: function gtag() { dataLayer.push(arguments); }
  // Using arguments (not ...args) is critical - GTM expects this pattern
  if (!window.gtag) {
    // eslint-disable-next-line prefer-rest-params
    (window as any).gtag = function () {
      // eslint-disable-next-line prefer-rest-params
      window.dataLayer.push(arguments);
    };
  }

  // Check cookie consent and set disable flag BEFORE GTM loads
  const consentCookieValue = document.cookie
    ?.split('; ')
    ?.find(cookie => cookie.includes('cookieconsent_status'))
    ?.split('=')?.[1];

  if (consentCookieValue !== 'allow') {
    (window as any)[`ga-disable-${measurementId}`] = true;
  }

  // Queue GA configuration - GTM will process when it loads
  window.gtag('js', new Date());
  window.gtag('config', measurementId, {
    cookie_flags: 'SameSite=None;Secure',
    send_page_view: false,
  });
};
